import React from 'react';
import theme from 'styles/theme';
import colours from 'styles/colours';
import FooterLink from './FooterLink';

const RELX_LOGO_HEIGHT = 18;

export default function AppFooter() {

    const footerLinks = [
        {href: 'https://risk.lexisnexis.com/copyright', text: 'Copyright © ' + (new Date().getFullYear()) + ' LexisNexis Risk Solutions.'},
        {href: 'https://risk.lexisnexis.com/terms', text: 'Terms & Conditions'},
        {href: 'https://risk.lexisnexis.com/privacy-policy', text: 'Privacy Policy'},
    ];

    const footerStyles = {
        ...theme.header,
        backgroundColor: theme.background.panel,
        padding: '6px 5px',
        fontSize: 11,
        borderTop: `1px solid ${colours.border.footer}`,
    };

    const linkListStyles = {
        display: 'flex',
        listStyle: 'none',
        margin: 0,
        padding: 0,
    };

    return (
        <footer style={footerStyles}>
            <section style={linkListStyles}>
                {footerLinks.map((link, index) => (
                    <FooterLink href={link.href} key={index}>
                        {link.text}
                    </FooterLink>
                ))}
            </section>
            <section style={{marginLeft: 'auto', display: 'flex', alignItems: 'center'}} id="footer-branding">
                <FooterLink href="https://www.relx.com/">
                    <img
                        src="/images/branding/logo-relx.png"
                        alt="Parent company RELX logo"
                        height={RELX_LOGO_HEIGHT}
                        style={{display: 'block', height: RELX_LOGO_HEIGHT, width: 'auto'}}
                    />
                </FooterLink>
            </section>
        </footer>
    );
}